module.exports = __webpack_public_path__ + "img/ssbg9.dc0b4ad9.jpg";